import request from './fetcher/request'

// 查询用户信息
function getUserInfoApi (data) {
  return request.post('/api/sdk/user/userInfo', data)
}

// 查询用户能使用哪些权限
function getPrivilegeInfoApi (data) {
  return request.post('/api/sdk/service/get', data)
}

// 用户修改信息 - 头像库
function getAvatarList (data) {
  return request.post('/api/sdk/user/modifyInfo/avatar', data)
}

// 用户修改信息
function modifyUserInfo (data) {
  return request.post('/api/sdk/user/modifyInfo', data)
}

/**
 * 用户信息
 * @typedef {Object} ContinuousInfo
 * @property {1 | 2} continuous_status 签约状态 1 - 未签约； 2 - 已签约，正在生效
 * @property {String} name 套餐名称
 * @property {String} next_deduction_time 下次续费时间
 * @property {Number} price 套餐价格，单位为分
 */

/**
 * 获取用户续费信息
 * @returns {ContinuousInfo}
 */
function getContinuousInfo () {
  return request.post('/api/sdk/service/deduction/continuous_status', {})
}

/**
 * 判断是否支付过sogou的订单
 */
function hasPayBySogou () {
  return request.post('/api/sdk/has_paid_with_sougou', {})
}

/**
 * 获取评论信息
 */
function getCommentInfoRequest (data) {
  return request.post('/api/sdk/displayuserfeedback/history', data)
}

/**
 * 用户评论展示AB测
 */
function getCommentInfoAbTestRequest (params) {
  return request.post('/api/sdk/easyab/query', params)
}

/**
 * 会员中心消息广播API
 */
function getMessageBroadList () {
  return request.post('/api/sdk/broadcast/list')
}

/**
 * 获取用户订单发票列表
 */
function getInvoiceListData () {
  return request.post('/api/sdk/midasinvoice/list', {})
}
/**
 * 提交发票信息
 */
function submitInvoiceInfo (data) {
  return request.post('/api/sdk/midasinvoice/apply', data)
}

/** 
 * 是否走米大师支付
 */
function isMidasPayRequest () {
  return request.post('/api/sdk/midaspay/should_use_midas')
}

/**
 * 搜索企业信息
 */
function searchEnterpriseInfo (data) {
  return request.post('/api/sdk/companies/search', data)
}

export {
  getUserInfoApi, getPrivilegeInfoApi, getAvatarList, modifyUserInfo, getContinuousInfo,
  hasPayBySogou, getCommentInfoRequest, getCommentInfoAbTestRequest, getMessageBroadList,
  getInvoiceListData, submitInvoiceInfo, isMidasPayRequest, searchEnterpriseInfo
}
